import { Link, useNavigate } from 'react-router-dom'
import React from 'react'

import CommonBtn from '../commonbtn'
//import SelectDropDown from '../Select Dropdown'
import './style.scss'
import SelectDropDown from '../Select Dropdown'
//import { useEffect } from 'react'
//import StarIcon from './star-icon'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { handleCTEnrollNowClick } from '../../../../CleverTap/buttonClicked';
import EnrlNowBtn from '../enrollNowBtn'
// import { faHelicopterSymbol } from '@fortawesome/free-solid-svg-icons'

// const Error = () => {
//   <small style={{ color: 'red', marginLeft: '0' }}>
//     *Please Enter Your 10 Digit Phone Number!
//   </small>
// }



const CourseCard = ({
  color,
  key,
  courseTitle,
  description,
  path,
  img = 'https://ecom-static-site-prod.s3.ap-south-1.amazonaws.com/Courses/course%20%281%29.png',
  //rating = 5,
  dates = [],
  fees,
  timing,
  tenure,
  pageName,
  courseCategory,
  courseSubType,
  onlineMode,
  residentialMode,
  nonResidentialMode,
  residentialLocation,
  nonResidentialLocation,
  courseType,
  language,
  category,
  batch,
  nonResidential,
  residential,
  online, onCampus,
  detailUrl
}) => {

  const coursesList = [
    {
      id: 1,
      ques: '200 hours TTC (Basic)',
      ans: [
        {
          url: '/one-month-ttc',
          text: ' 1 Month TTC Online & On Campus - English - Batch 1 ',
        },
        {
          url: '/200-hrs-part-time-ttc-on-campus-english',
          text: '2 Months TTC Online & On Campus – English - Batch 2',
        },
        {
          url: '/200-hrs-part-time-ttc-online-english',
          text: '2 Months TTC Online – English - Batch 3 ',
        },
        {
          url: '/200-hrs-part-time-ttc-online',
          text: '2 Months TTC Online – Hindi - Batch 4 ',
        },
        {
          url: '/weekend-teacher-training-course',
          text: '3 Months Weekend TTC Online – English - Batch 5',
        },
        // {
        //   url: '/200-hrs-part-time-ttc-online-english-batch-6',
        //   text: '2 Months TTC Online – English - Batch 6',
        // },
        // /200-hrs-part-time-ttc-online-english-batch-5
      ],
    },
    {
      id: 2,
      ques: '500 Hours TTC (Intermediate)',
      ans: [
        {
          url: '/500-hrs-online-yoga-teacher-training-course-intermediate-level',
          text: ' 3 Months TTC - Online - English',
        },
      ],
    },
    {
      id: 3,
      ques: '900 Hour Courses',
      ans: [
        {
          url: '/3-months-advanced-teacher-training-course',
          text: '3 Months TTC-On Campus-English',
        },
        {
          url: '/900-hours-advanced-teacher-training-course',
          text: '4 Months TTC-Online-English',
        },
        {
          url: '/seven-month-ttc',
          text: '7 Months TTC-Online & On Campus-English',
        },
        {
          url: '/seven-month-ttc-morning',
          text: '7 Months TTC- Morning Online - English',
        },
        { url: '/one-year-ttc', text: '1 Year TTC-Online & On Campus-Hindi' },
        {
          url: '/two-year-ttc',
          text: '2 Years TTC-Online & On Campus-English',
        },
      ],
    },
  ]
  const campsAccordian = [
    {
      id: 1,
      ques: '21 Days Better Living Course',
      ans: [
        {
          url: '/21-days-better-living-course',
          text: 'Morning On Campus – English - Batch 1',
        },
        {
          url: '/21-days-better-living-course-batch-2',
          text: 'Evening - Online & On Campus – English - Batch 2',
        },
        {
          url: '/21-days-better-living-course-batch-3',
          text: 'Evening - Online & On Campus – Hindi - Batch 3',
        },
        // {
        //   url: '/21-days-better-living-course-batch-4',
        //   text: 'Morning - Online – English - Batch 4',
        // },
      ],
    },
    {
      id: 2,
      ques: '7 Days Health Camp',
      ans: [
        {
          url: '/7-days-camp',
          text: '7 Days Health Camp - On Campus - Hindi',
        },
        {
          url: '/7-days-camp-english',
          text: '7 Days Health Camp - On Campus - English',
        },
      ],
    },
  ]



  const selectStyles = {
    cursor: 'pointer',
    background: color,
    borderColor: 'white',
    color: 'white',
    fontSize: '1.5rem',
    fontWeight: '900',
    borderWidth: '0.1rem',
    borderRadius: '20px',
    borderStyle: 'solid',
    maxWidth: 'fit-content',
  }
  // const [ratingArr, setRatingArr] = useState([])
  const { isLoggedIn } = useSelector((state) => state.auth)
  const [error, setError] = useState(0)



  // useEffect(() => {
  //   let arr = []
  //   for (let i = 0; i < rating; i++) {
  //     arr[i] = i
  //     setRatingArr(arr)
  //   }
  // }, [])
  const navigate = useNavigate()

  const [selectDate, setSetselectDate] = useState('null')//null
  // localStorage.setItem('selectedDate', selectDate)

  const checkEmpty = () => {
    if (dates.length !== 0) {
      if (selectDate === null) {
        setError(0)//1
      }
      else {
        setError(0)
      }
    }
  }
  const getStartDate = (date) => {
    console.log(date);
    
    if (date) {
      // Extract the first date range
      const firstDateRange = date;
      // Split to extract start date
      const startDateString = firstDateRange.split(' to ')[0]; // "30th September"
      // Remove ordinal suffix (like "th") and split the date
      const cleanedDateArray = startDateString.replace(/\d+(st|nd|rd|th)/, match => match.slice(0, -2)).split(' ');
      const day = cleanedDateArray[0]; // e.g. "30"
      const fullMonth = cleanedDateArray[1] != '-' ? cleanedDateArray[1] : ''; // e.g. "September"
      // Create a mapping of full month names to their short forms
      const monthShortForm = {
        January: 'Jan',
        February: 'Feb',
        March: 'Mar',
        April: 'Apr',
        May: 'May',
        June: 'Jun',
        July: 'Jul',
        August: 'Aug',
        September: 'Sep',
        October: 'Oct',
        November: 'Nov',
        December: 'Dec'
      };
      // Get the short form of the month
      const shortMonth = monthShortForm[fullMonth] || fullMonth;
      // Update the state with day and short month
      return `${day} ${shortMonth}`;
    }
    else {
      return '';
    }
  }

  const isRegular = (title) => {
    const array = ["Yoga Classes for Men (Regular Asana) - On Campus",
      "Yoga Classes for Women (Regular Asana) - On Campus",
      "Yoga Asana Regular Classes - (Men & Women) - Online Yoga Classes",
      "Weekend Yoga Asana Classes - (Men & Women) - On Campus",
      "Weekend Yoga Asana Classes - (Men & Women) - Online",
      "Children's Yoga Classes (Regular) - On Campus",
      "Children's Weekend Yoga Class - On Campus",
      "Advanced Yoga Asana Regular Class - Online (Only for TYI Teachers)",
      "Regular Pregnancy Yoga Classes - Online & On Campus",
      "Advanced Yoga Asana Regular Class - Online (Only for TYI Teachers)",
      "Healing Yoga Movement & Rhythm - Online",
      "Yog Prayas - Online",
      "Online Meditation Course  (Foundation Course)",
      "Regular Online Meditation Classes",
      "Couples’ Yoga Classes  - Online"
    ]
    return array.includes(title);
  }

  return (
    <div className="course-card">
      <div className="course-card-image">
        <img src={img} alt={courseTitle} onClick={() => {
          if (detailUrl) {
            window.location.href = detailUrl
          } else {
            navigate(`/${path}`)
          }
        }} loading='lazy' />
        {/* <div className="stars">
          {ratingArr.length !== 0 &&
            ratingArr.map((item, id) => <StarIcon key={id} />)}
        </div> */}
      </div>
      <div
        className="course-card-content"
        style={{
          background: `${color}`,
        }}
      >
        {/* <h4>{courseTitle?.slice(0, 55)}...</h4> */}
        <h4>{courseTitle}</h4>
        <h3>{description?.slice(0, 80)}{description?.length > 80 && <>...</>}</h3>

        <div style={{ marginTop: '-32px' }}></div>
        {(dates.length > 0 && !isRegular(courseTitle)) &&
          <div style={{ paddingBottom: '8px' }}>
            <span><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.0395 1.91511H11.5216V1.2893C11.5216 0.854363 11.1673 0.500488 10.7319 0.500488C10.2969 0.500488 9.94304 0.854363 9.94304 1.2893V1.91514H6.05689V1.2893C6.05689 0.854363 5.70261 0.500488 5.26717 0.500488C4.8322 0.500488 4.47836 0.854363 4.47836 1.2893V1.91514H1.96036C1.25823 1.91514 0.687012 2.48636 0.687012 3.18852V15.226C0.687012 15.9281 1.25823 16.4994 1.96036 16.4994H14.0395C14.7417 16.4994 15.3129 15.9282 15.3129 15.226V3.18852C15.3129 2.48636 14.7416 1.91511 14.0395 1.91511ZM10.3797 1.2893C10.3797 1.09514 10.5377 0.937176 10.7318 0.937176C10.9265 0.937176 11.0849 1.09514 11.0849 1.2893V2.97768C11.0849 3.17183 10.9265 3.3298 10.7318 3.3298C10.5377 3.3298 10.3797 3.17183 10.3797 2.97768V1.2893ZM4.91504 1.2893C4.91504 1.09514 5.07301 0.937176 5.26717 0.937176C5.46182 0.937176 5.6202 1.09514 5.6202 1.2893V2.97768C5.6202 3.17183 5.46186 3.3298 5.26717 3.3298C5.07301 3.3298 4.91504 3.17183 4.91504 2.97768V1.2893ZM1.96036 2.35183H4.47832V2.97768C4.47832 3.41264 4.83217 3.76652 5.26714 3.76652C5.70261 3.76652 6.05686 3.41264 6.05686 2.97768V2.35183H9.94295V2.97768C9.94295 3.41264 10.2968 3.76652 10.7318 3.76652C11.1672 3.76652 11.5215 3.41264 11.5215 2.97768V2.35183H14.0394C14.5008 2.35183 14.8761 2.72718 14.8761 3.18849V5.25733H1.12373V3.18849C1.12373 2.72718 1.49904 2.35183 1.96036 2.35183ZM1.12373 15.226V5.69405H14.8762V12.3703C14.6574 12.4767 14.4168 12.5326 14.1733 12.5326C13.7997 12.5326 13.4465 12.4067 13.1519 12.1684C13.126 12.1475 13.0956 12.1327 13.0631 12.1253C13.0306 12.1179 12.9968 12.118 12.9643 12.1257C12.9319 12.1334 12.9016 12.1484 12.8759 12.1696C12.8501 12.1908 12.8295 12.2176 12.8158 12.248C12.0403 13.9561 10.6328 15.3092 8.8497 16.0627H1.96036C1.49904 16.0627 1.12373 15.6873 1.12373 15.226ZM14.5436 12.9354C13.5006 14.361 11.9672 15.3847 10.2252 15.8352C10.6811 15.5464 11.1071 15.213 11.4969 14.8397C12.1619 14.2032 12.7005 13.4731 13.1005 12.6662C13.4238 12.8653 13.7899 12.9694 14.1732 12.9694C14.2978 12.9694 14.4218 12.9579 14.5436 12.9354ZM14.0395 16.0627H10.9809C12.5409 15.5225 13.9058 14.5345 14.8762 13.2202V15.226C14.8762 15.6873 14.5008 16.0627 14.0395 16.0627ZM4.04561 6.71808H2.59289C2.34695 6.71808 2.14689 6.91777 2.14689 7.16321V8.61596C2.14689 8.86189 2.34695 9.06196 2.59289 9.06196H4.04561C4.29104 9.06196 4.49073 8.86189 4.49073 8.61596V7.16321C4.49073 6.91777 4.29104 6.71808 4.04561 6.71808ZM4.05401 8.61596C4.05401 8.62089 4.04932 8.62527 4.04557 8.62527H2.59289C2.58854 8.62527 2.58357 8.6203 2.58357 8.61596V7.16321C2.58357 7.15949 2.58798 7.1548 2.59289 7.1548H4.04561C4.04995 7.1548 4.05404 7.15889 4.05404 7.16321V8.61596H4.05401ZM7.16551 6.71808H5.71276C5.46732 6.71808 5.26764 6.91777 5.26764 7.16321V8.61596C5.26764 8.86189 5.46732 9.06196 5.71276 9.06196H7.16551C7.41142 9.06196 7.61148 8.86189 7.61148 8.61596V7.16321C7.61148 6.91777 7.41142 6.71808 7.16551 6.71808ZM7.17479 8.61596C7.17479 8.6203 7.16986 8.62527 7.16551 8.62527H5.71276C5.70904 8.62527 5.70432 8.62089 5.70432 8.61596V7.16321C5.70432 7.15889 5.70842 7.1548 5.71276 7.1548H7.16551C7.17042 7.1548 7.17479 7.15949 7.17479 7.16321V8.61596ZM8.83351 9.06199H10.2863C10.5317 9.06199 10.7314 8.86193 10.7314 8.61599V7.16324C10.7314 6.9178 10.5317 6.71811 10.2863 6.71811H8.83351C8.58807 6.71811 8.38839 6.9178 8.38839 7.16324V8.61599C8.38839 8.86189 8.58804 9.06199 8.83351 9.06199ZM8.82507 7.16321C8.82507 7.15889 8.82917 7.1548 8.83351 7.1548H10.2863C10.2906 7.1548 10.2947 7.15889 10.2947 7.16321V8.61596C10.2947 8.62089 10.29 8.62527 10.2863 8.62527H8.83351C8.82979 8.62527 8.82507 8.62089 8.82507 8.61596V7.16321ZM11.9543 9.06199H13.407C13.6524 9.06199 13.8521 8.86193 13.8521 8.61599V7.16324C13.8521 6.9178 13.6524 6.71811 13.407 6.71811H11.9543C11.7083 6.71811 11.5083 6.9178 11.5083 7.16324V8.61599C11.5083 8.86189 11.7083 9.06199 11.9543 9.06199ZM11.9449 7.16321C11.9449 7.15949 11.9494 7.1548 11.9543 7.1548H13.407C13.4114 7.1548 13.4154 7.15889 13.4154 7.16321V8.61596C13.4154 8.62089 13.4108 8.62527 13.407 8.62527H11.9543C11.95 8.62527 11.9449 8.62021 11.9449 8.61596V7.16321ZM4.04561 9.83883H2.59289C2.34695 9.83883 2.14689 10.0385 2.14689 10.284V11.7367C2.14689 11.9821 2.34695 12.1818 2.59289 12.1818H4.04561C4.29104 12.1818 4.49073 11.9821 4.49073 11.7367V10.284C4.49073 10.0385 4.29104 9.83883 4.04561 9.83883ZM4.05401 11.7367C4.0539 11.7389 4.05297 11.741 4.05141 11.7426C4.04985 11.7441 4.04777 11.745 4.04557 11.7451H2.59289C2.58798 11.7451 2.58357 11.7405 2.58357 11.7367V10.284C2.58357 10.2803 2.58798 10.2756 2.59289 10.2756H4.04561C4.04995 10.2756 4.05404 10.2796 4.05404 10.284V11.7367H4.05401ZM7.16551 9.83883H5.71276C5.46732 9.83883 5.26764 10.0385 5.26764 10.284V11.7367C5.26764 11.9821 5.46732 12.1818 5.71276 12.1818H7.16551C7.41142 12.1818 7.61148 11.9821 7.61148 11.7367V10.284C7.61148 10.0385 7.41142 9.83883 7.16551 9.83883ZM7.17479 11.7367C7.17479 11.7405 7.17042 11.7451 7.16551 11.7451H5.71276C5.71056 11.745 5.70848 11.7441 5.70692 11.7426C5.70536 11.741 5.70444 11.7389 5.70432 11.7367V10.284C5.70432 10.2796 5.70842 10.2756 5.71276 10.2756H7.16551C7.17042 10.2756 7.17479 10.2803 7.17479 10.284V11.7367ZM10.2863 12.1819C10.5317 12.1819 10.7314 11.9822 10.7314 11.7367V10.284C10.7314 10.0386 10.5317 9.83886 10.2863 9.83886H8.83351C8.58807 9.83886 8.38839 10.0386 8.38839 10.284V11.7367C8.38839 11.9822 8.58807 12.1819 8.83351 12.1819H10.2863ZM8.82507 11.7367V10.284C8.82507 10.2796 8.82917 10.2756 8.83351 10.2756H10.2863C10.2906 10.2756 10.2947 10.2796 10.2947 10.284V11.7367C10.2946 11.7389 10.2937 11.741 10.2921 11.7426C10.2905 11.7441 10.2885 11.745 10.2863 11.7451H8.83351C8.83131 11.745 8.82923 11.7441 8.82767 11.7426C8.82611 11.741 8.82519 11.7389 8.82507 11.7367ZM4.04561 12.9587H2.59289C2.34695 12.9587 2.14689 13.1588 2.14689 13.4047V14.8575C2.14689 15.1029 2.34695 15.3026 2.59289 15.3026H4.04561C4.29104 15.3026 4.49073 15.1029 4.49073 14.8575V13.4047C4.49073 13.1588 4.29104 12.9587 4.04561 12.9587ZM4.05401 14.8575C4.05401 14.8618 4.04992 14.8659 4.04557 14.8659H2.59289C2.58798 14.8659 2.58357 14.8612 2.58357 14.8575V13.4047C2.58357 13.4004 2.58854 13.3954 2.59289 13.3954H4.04561C4.04932 13.3954 4.05404 13.3998 4.05404 13.4047V14.8575H4.05401ZM7.16551 12.9587H5.71276C5.46732 12.9587 5.26764 13.1588 5.26764 13.4047V14.8575C5.26764 15.1029 5.46732 15.3026 5.71276 15.3026H7.16551C7.41142 15.3026 7.61148 15.1029 7.61148 14.8575V13.4047C7.61148 13.1588 7.41142 12.9587 7.16551 12.9587ZM7.17479 14.8575C7.17479 14.8612 7.17042 14.8659 7.16551 14.8659H5.71276C5.71056 14.8658 5.70847 14.8649 5.70691 14.8633C5.70535 14.8618 5.70443 14.8597 5.70432 14.8575V13.4047C5.70432 13.3998 5.70901 13.3954 5.71276 13.3954H7.16551C7.16986 13.3954 7.17479 13.4004 7.17479 13.4047V14.8575Z" fill="white" />
            </svg>
            </span>
            <span className='det-label'>Start {isRegular(courseTitle) ? 'Time:' : 'Dates:'} </span>
            <span className='det-val'>{getStartDate(dates[0])}</span>
            {dates.length - 1 > 0 &&
              <span className='det-label' style={{ fontSize: '11px' }}>+{dates.length - 1} More </span>}
          </div>}

        {language &&
          <div style={{ paddingBottom: '8px' }}>
            <span><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.9971 13.3877C11.4827 13.1727 10.9413 12.9948 10.3803 12.8555C10.2742 13.1247 10.1572 13.3818 10.0292 13.6239M11.9971 13.3877L9.985 13.6005M11.9971 13.3877C11.1355 14.2543 10.036 14.8836 8.80604 15.1687M11.9971 13.3877L8.80604 15.1687M10.0292 13.6239L9.985 13.6005M10.0292 13.6239C10.0292 13.6239 10.0292 13.6239 10.0292 13.6239L9.985 13.6005M10.0292 13.6239C9.67662 14.2915 9.26215 14.8127 8.80604 15.1687M9.985 13.6005C9.61222 14.3064 9.17138 14.8443 8.68814 15.1949C8.72757 15.1865 8.76687 15.1778 8.80604 15.1687M5.82209 15.1687C5.36592 14.8127 4.9512 14.2915 4.59861 13.6239C4.5986 13.6239 4.5986 13.6239 4.5986 13.6239L4.64281 13.6005C4.50938 13.348 4.38781 13.079 4.27812 12.7965L5.82209 15.1687ZM5.82209 15.1687C4.59182 14.8836 3.4923 14.2543 2.63071 13.3877C3.14507 13.1727 3.68647 12.9948 4.24753 12.8555L5.82209 15.1687ZM4.59861 3.83904C4.47065 4.08116 4.35364 4.3382 4.24754 4.60714C3.68647 4.46809 3.14508 4.29019 2.63071 4.07527C3.49226 3.20867 4.59172 2.5794 5.82193 2.29424C5.36581 2.65014 4.95115 3.17147 4.59861 3.83904ZM4.59861 3.83904L4.64281 3.8624M4.59861 3.83904L4.64281 3.8624M4.64281 3.8624C4.50938 4.1149 4.38781 4.38397 4.27812 4.66615L4.64281 3.8624ZM8.889 2.36315C8.85992 2.33877 8.8304 2.31492 8.80047 2.29162C9.11115 2.36317 9.41629 2.45731 9.71344 2.57334V3.30503C9.46334 2.92789 9.18775 2.61231 8.889 2.36315ZM8.889 2.36315L8.85688 2.40146M8.889 2.36315C8.88896 2.36312 8.88893 2.36309 8.8889 2.36307L8.85688 2.40146M8.85688 2.40146C9.16796 2.6609 9.45452 2.9942 9.71344 3.39644L8.68256 2.26561C8.74225 2.3088 8.80039 2.35412 8.85688 2.40146ZM10.3382 5.86334C10.2699 5.94717 10.1707 5.99334 10.0672 5.99334C10.0274 5.99334 9.98668 5.98641 9.94728 5.97231C9.94726 5.97231 9.94724 5.9723 9.94722 5.97229L9.96406 5.92522C9.84219 5.88178 9.76344 5.77022 9.76344 5.64084L10.3382 5.86334ZM10.3382 5.86334L10.3456 5.85423C10.5554 6.68497 10.6725 7.59706 10.6877 8.52522H7.52031V5.38519C8.26387 5.37414 8.99951 5.30252 9.71344 5.17219L10.2994 5.83178L10.3381 5.86342L10.3382 5.86334ZM4.96359 13.4312L4.96357 13.4312C4.85167 13.2198 4.74874 12.9964 4.65408 12.7623C5.44415 12.5953 6.26817 12.5033 7.10781 12.4903V15.2954C6.31387 15.2003 5.55698 14.5551 4.96359 13.4312ZM4.96355 4.03175L4.96359 4.03169C5.55698 2.9078 6.31387 2.26265 7.10781 2.16755V4.97266C6.26817 4.95965 5.44415 4.86767 4.65408 4.70061C4.74875 4.46647 4.85167 4.24287 4.96355 4.03175ZM14.3341 8.73147C14.3341 7.40263 13.966 6.1238 13.2667 5.00897H14.9169C15.3523 5.00897 15.7063 4.65534 15.7063 4.21959V2.03771C15.7063 1.60229 15.3523 1.24834 14.9169 1.24834H10.5028C10.0674 1.24834 9.71344 1.60229 9.71344 2.03771V2.13247C8.94612 1.85314 8.14041 1.71146 7.31406 1.71146C5.43893 1.71146 3.6759 2.44173 2.34996 3.76736L2.34996 3.76736C1.02402 5.0933 0.29375 6.85633 0.29375 8.73147C0.29375 10.6066 1.02402 12.3696 2.34996 13.6953C3.6759 15.0212 5.43893 15.7515 7.31406 15.7515C9.18889 15.7515 10.9519 15.0212 12.2779 13.6953C13.6038 12.3696 14.3341 10.6066 14.3341 8.73147ZM12.7737 5.00897C13.4863 6.05169 13.8796 7.26096 13.9183 8.52522H11.1002C11.0833 7.45401 10.9345 6.40139 10.6668 5.46063L10.7906 5.30869C10.9508 5.11222 11.1685 5.00897 11.4219 5.00897H12.7737ZM11.0941 3.60272H13.3397C13.3983 3.60272 13.4459 3.65033 13.4459 3.70897C13.4459 3.76785 13.3984 3.81522 13.3397 3.81522H11.0941C11.0354 3.81522 10.9878 3.76785 10.9878 3.70897C10.9878 3.65033 11.0354 3.60272 11.0941 3.60272ZM14.3256 2.68803H11.0941C11.0354 2.68803 10.9878 2.64041 10.9878 2.58178C10.9878 2.52314 11.0354 2.47553 11.0941 2.47553H14.3256C14.3845 2.47553 14.4319 2.52308 14.4319 2.58178C14.4319 2.64048 14.3845 2.68803 14.3256 2.68803ZM7.52031 12.4903C8.35969 12.5033 9.18399 12.5953 9.97379 12.7623C9.87936 12.9964 9.77618 13.2198 9.66453 13.4312C9.07084 14.5551 8.31395 15.2003 7.52031 15.2954V12.4903ZM4.50791 12.3719C4.15671 11.3579 3.95945 10.1778 3.93976 8.93772H7.10781V12.0777C6.21818 12.0909 5.3446 12.1906 4.50791 12.3719ZM4.10466 12.4665C3.48802 12.6217 2.8943 12.8226 2.33195 13.0669C1.36211 11.9539 0.758343 10.5146 0.709803 8.93772H3.52724C3.54686 10.2055 3.74698 11.4168 4.10466 12.4665ZM3.52724 8.52522H0.709803C0.758343 6.94829 1.36211 5.509 2.33195 4.39598C2.8943 4.64037 3.48802 4.84124 4.10466 4.99647C3.74698 6.04614 3.54686 7.25747 3.52724 8.52522ZM4.50791 5.09102C5.34459 5.27236 6.21818 5.372 7.10781 5.38519V8.52522H3.93976C3.95944 7.28485 4.15671 6.10501 4.50791 5.09102ZM7.52031 2.16806C8.33106 2.26859 9.12169 2.96106 9.71344 4.12653V4.7526C9.00108 4.88715 8.26507 4.96116 7.52031 4.97266V2.16806ZM7.52031 8.93772H10.6881C10.6684 10.1778 10.4711 11.3579 10.1199 12.3719C9.28322 12.1906 8.40965 12.0909 7.52031 12.0777V8.93772ZM10.5232 12.4665C10.8808 11.4168 11.081 10.2055 11.1006 8.93772H13.9183C13.8695 10.5146 13.2657 11.9539 12.2959 13.0669C11.7335 12.8226 11.1398 12.6217 10.5232 12.4665Z" fill="white" stroke="white" stroke-width="0.1" />
            </svg>
            </span>
            <span className='det-label'>Language: </span>
            <span className='det-val'>{language}</span>
          </div>}

        {(online || onCampus) &&
          <div style={{ paddingBottom: '8px' }}>
            <span><svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.6547 0.0852051H9.1395C8.91541 0.0854697 8.70057 0.174608 8.54211 0.333065C8.38365 0.491523 8.29451 0.706362 8.29425 0.930455V1.97395H2.435C2.15397 1.97429 1.88455 2.08607 1.68583 2.28479C1.48712 2.4835 1.37533 2.75293 1.375 3.03395V10.8135H0.75C0.683696 10.8135 0.620107 10.8398 0.573223 10.8867C0.526339 10.9336 0.5 10.9972 0.5 11.0635C0.5 12.0842 1.33025 12.9145 2.351 12.9145H13.649C14.6698 12.9145 15.5 12.0842 15.5 11.0635C15.5 10.9972 15.4737 10.9336 15.4268 10.8867C15.3799 10.8398 15.3163 10.8135 15.25 10.8135H14.625V4.9762H14.6547C14.8788 4.97594 15.0937 4.8868 15.2521 4.72834C15.4106 4.56989 15.4997 4.35505 15.5 4.13095V0.930455C15.4997 0.706362 15.4106 0.491523 15.2521 0.333065C15.0937 0.174608 14.8788 0.0854697 14.6547 0.0852051ZM9.9245 5.9612C9.97023 5.97993 10.0205 5.98477 10.0689 5.97513C10.1174 5.96548 10.1619 5.94177 10.197 5.90695L11.1278 4.9762H13.14V10.8135H9.1455V10.1257C9.1455 9.40295 8.8645 8.72396 8.35425 8.21345C8.09416 7.95524 7.78396 7.753 7.44275 7.6192C7.69089 7.4544 7.89444 7.2308 8.03528 6.96831C8.17611 6.70582 8.24988 6.41259 8.25 6.1147C8.25 5.11795 7.439 4.30695 6.44225 4.30695C5.4455 4.30695 4.63425 5.11795 4.63425 6.1147C4.63439 6.41195 4.70783 6.70457 4.84807 6.96665C4.98831 7.22873 5.19103 7.45218 5.43825 7.61721C4.4315 8.0212 3.739 9.01295 3.739 10.1257V10.8135H2.86025V3.45896H8.2945V4.13095C8.29476 4.35505 8.3839 4.56989 8.54236 4.72834C8.70082 4.8868 8.91566 4.97594 9.13975 4.9762H9.77025V5.7302C9.77025 5.8312 9.83125 5.92245 9.9245 5.9612ZM6.177 7.9392C6.1815 7.9387 6.1855 7.93746 6.19 7.93695C6.34817 7.91879 6.50783 7.91761 6.66625 7.93345L6.67425 7.9347V9.3412C6.58225 9.43246 6.5075 9.5067 6.426 9.5887C6.34375 9.5067 6.26925 9.43246 6.177 9.3412V7.9392ZM6.44225 7.42245C5.721 7.42245 5.13425 6.8357 5.13425 6.11445C5.13425 5.3932 5.721 4.8067 6.44225 4.8067C7.1635 4.8067 7.75 5.39346 7.75 6.11445C7.75 6.83545 7.16325 7.42245 6.44225 7.42245ZM5.7515 9.62345C5.9465 9.81595 6.0555 9.9247 6.25025 10.1195C6.29712 10.1663 6.3607 10.1927 6.427 10.1927H6.42775C6.4607 10.1927 6.49331 10.1861 6.52369 10.1733C6.55408 10.1606 6.58163 10.1419 6.60475 10.1185C6.79675 9.92395 6.90525 9.81545 7.09975 9.62345C7.14725 9.57645 7.174 9.51245 7.174 9.44545V8.04796C7.48501 8.1565 7.76753 8.33382 8.0005 8.5667C8.20566 8.77101 8.36828 9.01397 8.47895 9.28152C8.58962 9.54907 8.64614 9.83592 8.64525 10.1255V10.8132H4.2385V10.1255C4.2385 9.19995 4.82675 8.37846 5.67675 8.0622V9.4452C5.67675 9.5122 5.7035 9.5762 5.751 9.6232L5.7515 9.62345ZM1.875 3.0342C1.8752 2.88574 1.93426 2.74342 2.03924 2.63844C2.14422 2.53347 2.28654 2.4744 2.435 2.4742H8.29425V2.9592H2.61C2.5437 2.9592 2.48011 2.98554 2.43322 3.03243C2.38634 3.07931 2.36 3.1429 2.36 3.2092V10.8137H1.875V3.0342ZM13.649 12.4147H2.351C2.03616 12.4143 1.73129 12.3042 1.48894 12.1032C1.24658 11.9022 1.08189 11.623 1.02325 11.3137H1.62275L1.62525 11.3142H3.975C3.97975 11.3145 3.984 11.317 3.989 11.317H8.89575C8.90075 11.317 8.90475 11.3145 8.90975 11.3142H14.3752L14.3778 11.3137H14.9773C14.9186 11.623 14.7539 11.9022 14.5115 12.1032C14.2692 12.3041 13.9643 12.4143 13.6495 12.4147H13.649ZM14.125 10.8137H13.64V4.97645H14.125V10.8137ZM15 4.1312C15 4.32146 14.845 4.47645 14.6547 4.47645H11.0243C10.9914 4.47642 10.9589 4.48287 10.9286 4.49544C10.8982 4.50802 10.8707 4.52646 10.8475 4.5497L10.2703 5.12695V4.72645C10.2703 4.66015 10.2439 4.59656 10.197 4.54968C10.1501 4.50279 10.0866 4.47645 10.0203 4.47645H9.13975C8.94925 4.47645 8.7945 4.32146 8.7945 4.1312V3.21295C8.7945 3.2117 8.79525 3.21071 8.79525 3.2092C8.79525 3.20771 8.7945 3.20696 8.7945 3.20546V2.2277C8.7945 2.22645 8.79525 2.22546 8.79525 2.22395C8.79525 2.22246 8.7945 2.2217 8.7945 2.2202V0.930205C8.7945 0.739705 8.9495 0.584955 9.13975 0.584955H14.655C14.8453 0.584955 15.0002 0.739955 15.0002 0.930205V4.1307L15 4.1312Z" fill="white" />
              <path d="M13.504 1.74731H10.1772C10.1109 1.74731 10.0474 1.77365 10.0005 1.82054C9.95359 1.86742 9.92725 1.93101 9.92725 1.99731C9.92725 2.06362 9.95359 2.12721 10.0005 2.17409C10.0474 2.22098 10.1109 2.24731 10.1772 2.24731H13.504C13.5703 2.24731 13.6339 2.22098 13.6808 2.17409C13.7277 2.12721 13.754 2.06362 13.754 1.99731C13.754 1.93101 13.7277 1.86742 13.6808 1.82054C13.6339 1.77365 13.5703 1.74731 13.504 1.74731ZM13.504 2.60356H10.1772C10.1109 2.60356 10.0474 2.6299 10.0005 2.67679C9.95359 2.72367 9.92725 2.78726 9.92725 2.85356C9.92725 2.91987 9.95359 2.98346 10.0005 3.03034C10.0474 3.07723 10.1109 3.10356 10.1772 3.10356H13.504C13.5703 3.10356 13.6339 3.07723 13.6808 3.03034C13.7277 2.98346 13.754 2.91987 13.754 2.85356C13.754 2.78726 13.7277 2.72367 13.6808 2.67679C13.6339 2.6299 13.5703 2.60356 13.504 2.60356Z" fill="white" />
            </svg>
            </span>
            <span className='det-label'>Course Type: </span>
            <span className='det-val'>
              {online && 'Online'}
              {(online && (onCampus)) && ' & '}
              {(onCampus) && 'On Campus'}
            </span>
          </div>}

        {tenure &&
          <div>
            <span><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3484 9.38512C14.2314 5.75494 11.2476 2.84374 7.58917 2.84374C3.85671 2.84374 0.826425 5.87402 0.826425 9.60648C0.826425 12.8839 3.16282 15.62 6.25957 16.2384C6.33298 16.2531 6.39755 16.2963 6.4391 16.3586C6.48065 16.4209 6.49577 16.4971 6.48114 16.5705C6.46646 16.644 6.42322 16.7085 6.36094 16.7501C6.29865 16.7917 6.22242 16.8068 6.14899 16.7922C2.79354 16.1222 0.261719 13.1577 0.261719 9.60648C0.261719 5.96212 2.92801 2.93557 6.41465 2.37284V1.69474H5.56618C5.49129 1.69474 5.41948 1.66499 5.36652 1.61204C5.31357 1.55909 5.28382 1.48727 5.28382 1.41239V0.348515C5.28382 0.27363 5.31357 0.201813 5.36652 0.148861C5.41948 0.0959099 5.49129 0.0661621 5.56618 0.0661621H9.35002C9.42491 0.0661621 9.49673 0.0959099 9.54968 0.148861C9.60263 0.201813 9.63238 0.27363 9.63238 0.348515V1.41239C9.63238 1.48727 9.60263 1.55909 9.54968 1.61204C9.49673 1.66499 9.42491 1.69474 9.35002 1.69474H8.50155V2.3354C12.0364 2.77523 14.7931 5.7369 14.9126 9.36119L15.2564 9.01735C15.3666 8.90716 15.5456 8.90716 15.6557 9.01735C15.7659 9.12754 15.7659 9.30645 15.6557 9.41663L14.8182 10.2542C14.792 10.2805 14.7608 10.3013 14.7266 10.3154C14.6923 10.3296 14.6556 10.3369 14.6185 10.3369C14.5814 10.3369 14.5447 10.3296 14.5105 10.3154C14.4762 10.3013 14.4451 10.2805 14.4189 10.2542L13.5227 9.35805C13.4125 9.24786 13.4125 9.06892 13.5227 8.95873C13.6329 8.84854 13.8118 8.84854 13.922 8.95873L14.3484 9.38512ZM6.97935 2.30409C7.29782 2.27782 7.61765 2.27216 7.93685 2.28715V1.69474H6.97935V2.30409ZM9.06767 0.630868H5.84853V1.13003H9.06767V0.630868ZM13.4767 12.9343C13.5136 12.8692 13.5749 12.8214 13.6471 12.8015C13.7193 12.7815 13.7964 12.791 13.8616 12.8279C13.9267 12.8649 13.9745 12.9262 13.9944 12.9983C14.0144 13.0705 14.0048 13.1476 13.9679 13.2128C13.9149 13.3063 13.8599 13.3987 13.8028 13.4898C13.763 13.5532 13.6996 13.5982 13.6267 13.615C13.5537 13.6317 13.477 13.6188 13.4136 13.5791C13.2815 13.4964 13.2415 13.322 13.3242 13.1899C13.3769 13.1058 13.4278 13.0206 13.4767 12.9343ZM12.6069 14.1385C12.6572 14.083 12.7274 14.0497 12.8022 14.0459C12.877 14.0421 12.9502 14.0682 13.0058 14.1184C13.1213 14.2229 13.1304 14.4016 13.0259 14.5172C12.8817 14.6766 12.7307 14.8297 12.5732 14.976C12.4589 15.0821 12.2801 15.0755 12.1741 14.9613C12.1232 14.9064 12.0961 14.8335 12.0989 14.7587C12.1017 14.6839 12.134 14.6132 12.1889 14.5622C12.3343 14.4271 12.4738 14.2858 12.6069 14.1385ZM11.25 15.2923C11.381 15.2078 11.5559 15.2455 11.6404 15.3764C11.7249 15.5073 11.6872 15.6822 11.5563 15.7667C11.3757 15.8834 11.19 15.992 10.9998 16.0923C10.9335 16.1272 10.8561 16.1344 10.7846 16.1122C10.7131 16.0901 10.6533 16.0405 10.6183 15.9742C10.5834 15.908 10.5763 15.8306 10.5984 15.7591C10.6205 15.6876 10.6702 15.6277 10.7364 15.5928C10.9119 15.5002 11.0833 15.4 11.25 15.2923ZM9.64004 16.0522C9.71139 16.0295 9.78883 16.0361 9.85534 16.0705C9.92184 16.1049 9.97197 16.1643 9.99471 16.2356C10.0174 16.307 10.0108 16.3844 9.97643 16.4509C9.94205 16.5174 9.88266 16.5676 9.81132 16.5903C9.60636 16.6556 9.3986 16.7117 9.18866 16.7585C9.03654 16.7924 8.88552 16.6965 8.8516 16.5444C8.83534 16.4713 8.84875 16.3947 8.8889 16.3315C8.92906 16.2683 8.99266 16.2237 9.06573 16.2073C9.25937 16.1641 9.45099 16.1124 9.64004 16.0522ZM7.88691 16.3628C7.96171 16.3596 8.03474 16.3862 8.08994 16.4368C8.14513 16.4874 8.17798 16.5578 8.18126 16.6326C8.18447 16.7074 8.15784 16.7805 8.10724 16.8356C8.05664 16.8908 7.98621 16.9237 7.9114 16.927C7.80457 16.9316 7.69713 16.9339 7.58917 16.9339C7.43334 16.9339 7.30681 16.8074 7.30681 16.6516C7.30681 16.4958 7.43334 16.3692 7.58917 16.3692C7.68894 16.3692 7.78819 16.3671 7.88691 16.3628ZM7.53753 4.30372C10.4642 4.30372 12.8403 6.67979 12.8403 9.60648C12.8403 12.5332 10.4642 14.9093 7.53753 14.9093C4.61084 14.9093 2.23473 12.5332 2.23473 9.60648C2.23473 6.67979 4.61084 4.30372 7.53753 4.30372ZM7.53753 4.86842C4.92252 4.86842 2.79944 6.99147 2.79944 9.60648C2.79944 12.2215 4.92252 14.3446 7.53753 14.3446C10.1525 14.3446 12.2756 12.2215 12.2756 9.60648C12.2756 6.99147 10.1525 4.86842 7.53753 4.86842ZM4.57766 7.04663C4.52473 6.99367 4.495 6.92185 4.495 6.84697C4.495 6.7721 4.52473 6.70028 4.57766 6.64732C4.63062 6.5944 4.70243 6.56467 4.7773 6.56467C4.85217 6.56467 4.92398 6.5944 4.97694 6.64732L5.27659 6.94696C5.32951 6.99993 5.35924 7.07175 5.35924 7.14662C5.35924 7.2215 5.32951 7.29331 5.27659 7.34628C5.22362 7.3992 5.15181 7.42893 5.07693 7.42893C5.00206 7.42893 4.93024 7.3992 4.87727 7.34628L4.57766 7.04663ZM10.496 12.1663C10.5489 12.2193 10.5786 12.2911 10.5786 12.366C10.5786 12.4409 10.5489 12.5127 10.496 12.5656C10.443 12.6186 10.3712 12.6483 10.2963 12.6483C10.2214 12.6483 10.1496 12.6186 10.0967 12.5656L9.79702 12.266C9.68684 12.1558 9.68684 11.9769 9.79702 11.8667C9.90721 11.7565 10.0862 11.7565 10.1963 11.8667L10.496 12.1663ZM4.97694 12.5656C4.92398 12.6186 4.85217 12.6483 4.7773 12.6483C4.70243 12.6483 4.63062 12.6186 4.57766 12.5656C4.52473 12.5127 4.495 12.4409 4.495 12.366C4.495 12.2911 4.52473 12.2193 4.57766 12.1663L4.87727 11.8667C4.98746 11.7565 5.1664 11.7565 5.27659 11.8667C5.38678 11.9769 5.38678 12.1558 5.27659 12.266L4.97694 12.5656ZM7.25447 7.75301C7.25447 7.59719 7.38097 7.47066 7.53682 7.47066C7.69265 7.47066 7.81918 7.59719 7.81918 7.75301V9.44346L8.91644 10.0768C9.0514 10.1547 9.09774 10.3275 9.01985 10.4625C8.94195 10.5974 8.76912 10.6438 8.63415 10.5659L7.39565 9.85103C7.35272 9.82625 7.31707 9.7906 7.29229 9.74767C7.26751 9.70475 7.25447 9.65605 7.25447 9.60648V7.75301ZM7.25447 5.70549C7.25447 5.54967 7.38097 5.42314 7.53682 5.42314C7.69265 5.42314 7.81918 5.54967 7.81918 5.70549V6.12786C7.81918 6.28368 7.69265 6.41021 7.53682 6.41021C7.38097 6.41021 7.25447 6.28368 7.25447 6.12786V5.70549ZM11.4392 9.32413C11.595 9.32413 11.7216 9.45066 11.7216 9.60648C11.7216 9.7623 11.595 9.88883 11.4392 9.88883H11.0154C10.8596 9.88883 10.7331 9.7623 10.7331 9.60648C10.7331 9.45066 10.8596 9.32413 11.0154 9.32413H11.4392ZM10.0967 6.64732C10.1496 6.5944 10.2214 6.56467 10.2963 6.56467C10.3712 6.56467 10.443 6.5944 10.496 6.64732C10.5489 6.70028 10.5786 6.7721 10.5786 6.84697C10.5786 6.92185 10.5489 6.99367 10.496 7.04663L10.1963 7.34628C10.1434 7.3992 10.0716 7.42893 9.99668 7.42893C9.92181 7.42893 9.84999 7.3992 9.79702 7.34628C9.7441 7.29331 9.71438 7.2215 9.71438 7.14662C9.71438 7.07175 9.7441 6.99993 9.79702 6.94696L10.0967 6.64732ZM7.81918 13.5075C7.81918 13.6633 7.69265 13.7898 7.53682 13.7898C7.38097 13.7898 7.25447 13.6633 7.25447 13.5075V13.0851C7.25447 12.9293 7.38097 12.8028 7.53682 12.8028C7.69265 12.8028 7.81918 12.9293 7.81918 13.0851V13.5075ZM3.63584 9.88883C3.47998 9.88883 3.35348 9.7623 3.35348 9.60648C3.35348 9.45066 3.47998 9.32413 3.63584 9.32413H4.05817C4.21399 9.32413 4.34052 9.45066 4.34052 9.60648C4.34052 9.7623 4.21399 9.88883 4.05817 9.88883H3.63584Z" fill="white" />
            </svg>
            </span>
            <span className='det-label'>Duration: </span>
            <span className='det-val'>{tenure}</span>
          </div>}

        {/* <SelectDropDown currentValue={selectDate} changeCurrentValue={setSetselectDate} text={'Select Dates'} isStyles={selectStyles} /> */}
        <div className="course-card-dropdown">
          {/* <div style={dates.length !== 0 ? { visibility: 'visible' } : { visibility: 'hidden' }} ><SelectDropDown
            currentValue={selectDate}
            changeCurrentValue={setSetselectDate}
            text={'Select Date/Time'}
            isStyles={selectStyles}
            dates={dates}
          /></div> */}
          {/* <SelectDropDown
            dates={dates}
            text={'Select Dates'}
            isStyles={selectStyles}
          /> */}
        </div>
        <div className="Button-class">
          {detailUrl ? (
            <a href={detailUrl}>
              <CommonBtn text={'View details'} />
            </a>
          ) : (
            <Link
              to={
                selectDate === null
                  ? `/${path}`
                  : `/${path}`///?date=${selectDate}
              }
            >
              <CommonBtn text={'View details'} />
            </Link>
          )}
          <div onClick={checkEmpty}>
            {dates.length !== 0 ?
              (selectDate ? (
                <Link
                  to={
                    isLoggedIn
                      ? `/enrollment/${path}`///?date=${selectDate}
                      : `/user/sign-in?location=${path}`//&date=${selectDate}
                  }
                >
                  <EnrlNowBtn text={'Enroll Now'} buttonAction={() => handleCTEnrollNowClick({
                    courseTitle,
                    fees,
                    timing,
                    tenure,
                    pageName,
                    courseCategory,
                    courseSubType,
                    onlineMode,
                    residentialMode,
                    nonResidentialMode,
                    residentialLocation,
                    nonResidentialLocation,
                    courseType,
                    language,
                    category,
                    batch,
                    nonResidential,
                    residential,
                    online
                  })} />
                </Link>
              ) : (
                <EnrlNowBtn text={'Enroll Now'} buttonAction={() => handleCTEnrollNowClick({
                  courseTitle,
                  fees,
                  timing,
                  tenure,
                  pageName,
                  courseCategory,
                  courseSubType,
                  onlineMode,
                  residentialMode,
                  nonResidentialMode,
                  residentialLocation,
                  nonResidentialLocation,
                  courseType,
                  language,
                  category,
                  batch,
                  nonResidential,
                  residential,
                  online
                })} />
              )) : (path !== 'nutri-diet' ? <Link
                to={
                  isLoggedIn
                    ? `/enrollment/${path}` ///?date=${selectDate}
                    : `/user/sign-in?location=${path}`//&date=${selectDate}
                }
              >
                <EnrlNowBtn text={'Enroll Now'} buttonAction={() => handleCTEnrollNowClick({
                  courseTitle,
                  fees,
                  timing,
                  tenure,
                  pageName,
                  courseCategory,
                  courseSubType,
                  onlineMode,
                  residentialMode,
                  nonResidentialMode,
                  residentialLocation,
                  nonResidentialLocation,
                  courseType,
                  language,
                  category,
                  batch,
                  nonResidential,
                  residential,
                  online
                })} />
              </Link> : <Link to='/nutri-diet' ><EnrlNowBtn text={'Enroll Now'} buttonAction={() => handleCTEnrollNowClick({
                courseTitle,
                fees,
                timing,
                tenure,
                pageName,
                courseCategory,
                courseSubType,
                onlineMode,
                residentialMode,
                nonResidentialMode,
                residentialLocation,
                nonResidentialLocation,
                courseType,
                language,
                category,
                batch,
                nonResidential,
                residential,
                online
              })} /></Link>)}
          </div>
        </div>
      </div>
      {error === 1 && <small style={{ color: 'red', marginLeft: '0' }}>
        *Please Select Date/Time!
      </small>}
    </div>
  )
}

export default CourseCard
